import { read } from 'xlsx';

import { getExcelPartners } from 'utils/getExcelData';

import { ConstitutionExcelRawRow } from '../types/ConstitutionExcel';
import { mapExcelKeysToUppercase } from './mapExcelKeysToUppercase';

export type ParseConstitutionExcelResult =
  | { success: true; rows: ConstitutionExcelRawRow[] }
  | { success: false; error: string };

export const parseConstitutionExcel = async (
  file: File
): Promise<ParseConstitutionExcelResult> => {
  try {
    const data = await file.arrayBuffer();
    const workbook = read(data);
    const excelPartners = getExcelPartners(workbook);

    if (!Array.isArray(excelPartners)) {
      return { success: false, error: 'SHEET_NOT_FOUND' };
    }

    const rows = mapExcelKeysToUppercase(
      excelPartners as ConstitutionExcelRawRow[]
    );

    return { success: true, rows };
  } catch {
    return { success: false, error: 'SHEET_NOT_FOUND' };
  }
};
